<dx-popup
  [showTitle]="true"
  [title]="'Modifier les effectifs prévisionnels'"
  [(visible)]="displayEffectifDialog"
  [width]="800"
  [height]="'auto'"
  [maxHeight]="700"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  [style]="{'overflow':'visible'}"
  (onHidden)="closeDialog()"
>
  <div class="row">
    <div class="col-md-4">
      <div class="dx-field mt-3">
        <h3 class="first">Jours ouvrés</h3>
        <yo-tree-list
          #treeListJoursSemaineEff
          [data]="joursSemaine"
          [returnData]="true"
          key="value"
          displayValue="viewValue"
          mode="list"
          (onValueChange)="onChangeJoursSemaine($event)">
          <dxo-selection mode="multiple" [recursive]="true"></dxo-selection>
          <dxi-column dataField="libelle" caption="Tout sélectionner"></dxi-column>
        </yo-tree-list>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dx-field mt-3">
        <h3 class="first">Repas et régimes</h3>
        <yo-tree-list
          #treeListRepasListEff
          [data]="repas"
          [returnData]="true"
          key="id"
          displayValue="libelle"
          childValue="children"
          mode="groupedList"
          (onValueChange)="onChangeParentDenreeSelection($event)">
          <dxo-selection mode="multiple" [recursive]="true"></dxo-selection>
          <dxi-column dataField="libelle" caption="Tout sélectionner"></dxi-column>
        </yo-tree-list>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dx-field mt-3">
        <h3 class="first">Effectif prévisionnel</h3>
        <div class="input-group input-group-sm ">
          <input type="text" style="width: 60px;" [(ngModel)]="majEffectifPrev">
          <div class="input-group-append ">
            <span class="input-group-text">pers.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 text-right">
      <yo-button iconClass="fas fa-check" class="mg-r-5"
                 (onClick)="save(selectedJoursSemaine, selectedRepasList, selectedRegimeList, majEffectifPrev)"></yo-button>
    </div>
  </div>

</dx-popup>
